// app.component.ts
import { Component, inject, OnInit } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { MenubarComponent } from './components/menubar/menubar.component';
import { DarkModeService } from './services/dark-mode.service';

@Component({
  selector: 'bnpp-indx-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [HeaderComponent, FooterComponent, MenubarComponent, RouterOutlet],
  standalone: true,
})
export class AppComponent implements OnInit {
  title = 'bnpp-indx';
  private readonly darkModeService = inject(DarkModeService);

  public ngOnInit() {
    this.darkModeService.initDarkMode();
  }
}
